import React, {useEffect} from "react";
import "./About.css";
import { Container, Box, Link } from "@material-ui/core";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import EmailIcon from "@material-ui/icons/Email";
import SchoolRoundedIcon from '@material-ui/icons/SchoolRounded';
import PermContactCalendarRoundedIcon from '@material-ui/icons/PermContactCalendarRounded';
import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import EventIcon from '@material-ui/icons/Event';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import GetAppIcon from '@material-ui/icons/GetApp';
import ykprofile from "./images/ykprofile-min.jpg";
import resume from './images/resume.pdf'
import Aos from 'aos';
import "aos/dist/aos.css"

import Skill from "./Skill";
import Project from "./Project";
import Contact from "./Contact";
function About() {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    })
  }, [])

  return (
    <div className="about">
      <Container>
        <Box>
          <div className="about__profile">
            <img
              className="about__image"
              src={ykprofile}
              alt="yahiyakhan"
            />
            <div className="about__icons">
              <Link href="https://github.com/yhya38" className="icons__link">
                <GitHubIcon className="icons" data-aos="flip-up" />
              </Link>
              <Link href="https://www.linkedin.com/in/yahiya-khan-153a81184" className="icons__link">
                <LinkedInIcon className="icons" data-aos="flip-down" />
              </Link>
              <Link href="https://www.instagram.com/its_a_y.a.khan/" className="icons__link">
                <InstagramIcon className="icons" data-aos="flip-up" />
              </Link>
              <Link href="mailto:yahiyakhan2217@gmail.com" className="icons__link">
                <EmailIcon className="icons" abodata-aos="flip-down" />
              </Link>
            </div>
            <div className="about__myself">
              <div className="common" data-aos="fade-up">
                <h1>About Me</h1>
              </div>
              <p className="myself__info" data-aos="fade-up">
                Hey folks! <br /> My name is <span>Yahiya Khan</span>. I'm a
                Freelancer Web Developer based in Banglore. Currently pursuing
                bachelor's degree in Computer Science & Engineering at
                Visvesvaraya Technological University. I'm looking forward to
                work in-hand with the organizations which provide an intution of
                collective belonging, responsibility and an environment that
                nurtures the ideas of creativity. I have acquired the skills
                neccessary to built great and premium websites.
              </p>
              <div className="common" data-aos="fade-up">
                <DeveloperModeIcon className="common__icon" />
                <h1>Hire me</h1>
              </div>
              <p className="myself__info" data-aos="fade-up">
                Im open for collaborations. I can make for you great web
                designs, portfolios, landing pages and much others at good
                price.
              </p>
              <div className="details" data-aos="fade-up">
                <div className="common">
                  <PermContactCalendarRoundedIcon className="common__icon" />
                  <h1>Personal Details</h1>
                </div>
                <div className="personal__details">
                  <h3>Full Name</h3>
                  <h3>Md Yahiyya Khan</h3>
                </div>
                <div className="personal__details">
                  <div className="personal__detailsIcon">
                    <EventIcon />
                    <h3>Date of Birth</h3>
                  </div>
                  <h3>05-08-1998</h3>
                </div>
                <div className="personal__details">
                  <div className="personal__detailsIcon">
                    <LocationOnIcon />
                    <h3>Address</h3>
                  </div>

                  <h3>Noor khan akhada Humnabad</h3>
                </div>
                <div className="personal__details">
                  <div className="personal__detailsIcon">
                    <EmailIcon />
                    <h3>Email</h3>
                  </div>

                  <h3>yahiyakhan2217@gmail.com</h3>
                </div>
                <div className="personal__details">
                  <div className="personal__detailsIcon">
                    <PhoneIcon />
                    <h3>Phone no</h3>
                  </div>

                  <h3>9036103964</h3>
                </div>
                <div className="personal__details">
                  <h3>Freelancer</h3>
                  <h3>Available</h3>
                </div>
              </div>
              <div className="education" data-aos="fade-up">
                <div className="common">
                  <SchoolRoundedIcon className="common__icon" />
                  <h1>Education</h1>
                </div>
                <div className="educaton__First">
                  <h3>PCMB</h3>
                  <p>Studied in Shaheen Pu College Bidar</p>
                  <small>2015-2017</small>
                </div>
                <div className="educaton__First">
                  <h3>Computer Science & Engineering</h3>
                  <p>Studying in Ghousia College of Engineering Ramanagaram</p>
                  <small>2017-2021</small>
                </div>
              </div>
              <div className="resume" data-aos="flip-up">
                <h1>My Resume</h1>
                <Link 
                  target="_blank"
                  href={resume}
                  className="resume__content">
                  <h3>Open CV</h3>
                  <GetAppIcon />
                </Link>
              </div>
              <Project />
              <Skill />
              <Contact />
            </div>
          </div>
        </Box>
      </Container>
    </div>
  );
}


export default About;
